import BaseQuery from "../common/BaseQuery";

export default class AnketaParams extends BaseQuery {
    static get(event_id, lang, successCb, errCb) {

        let params = {
            p: 'api',
            op: 'anketa',
            lang: !!lang ? lang : 'ru',
            event_id: event_id
        };

        AnketaParams.queryGet(params, (data) => successCb(data.data), errCb);
    }

    static paramNames() {
        return [
            'event_name',
            'logo',
            'fields'
        ];
    }
}

